import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccountForensicWatermarkingPoliciesFragment = { __typename?: 'Account', id: string, resourceControlPolicies?: { __typename?: 'ResourceControlPolicies', forensicWatermark?: { __typename?: 'ForensicWatermarkSettings', adminInternal?: boolean | null, adminCanDisableInShares?: boolean | null, commentOnlyInternal?: boolean | null, editAndShareInternal?: boolean | null, editAndShareCanDisableInShares?: boolean | null, editInternal?: boolean | null, fallback?: Types.ForensicWatermarkFallback | null, fullAccessInternal?: boolean | null, fullAccessCanDisableInShares?: boolean | null, requiredForShares?: boolean | null, viewerInternal?: boolean | null } | null } | null };

export type WorkspaceForensicWatermarkingPoliciesFragment = { __typename?: 'Workspace', id: string, resourceControlPolicies?: { __typename?: 'WorkspaceResourceControlPolicies', forensicWatermark?: { __typename?: 'ForensicWatermarkSettings', adminInternal?: boolean | null, adminCanDisableInShares?: boolean | null, commentOnlyInternal?: boolean | null, editAndShareInternal?: boolean | null, editAndShareCanDisableInShares?: boolean | null, editInternal?: boolean | null, fallback?: Types.ForensicWatermarkFallback | null, fullAccessInternal?: boolean | null, fullAccessCanDisableInShares?: boolean | null, requiredForShares?: boolean | null, viewerInternal?: boolean | null } | null } | null };

export type ShareForensicWatermarkingPolicies_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, forensicWatermarkEnabled?: boolean | null, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', forensicWatermark?: { __typename?: 'ForensicWatermarkSettings', requiredForShares?: boolean | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canDisableForensicWatermarkingInShares?: boolean | null } | null } | null };

export type ShareForensicWatermarkingPolicies_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, forensicWatermarkEnabled?: boolean | null, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', forensicWatermark?: { __typename?: 'ForensicWatermarkSettings', requiredForShares?: boolean | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canDisableForensicWatermarkingInShares?: boolean | null } | null } | null };

export type ShareForensicWatermarkingPoliciesFragment = ShareForensicWatermarkingPolicies_AdHocAssetsShare_Fragment | ShareForensicWatermarkingPolicies_CollectionShare_Fragment;

export type AssetForensicallyWatermarked_AudioAsset_Fragment = { __typename?: 'AudioAsset' };

export type AssetForensicallyWatermarked_DocumentAsset_Fragment = { __typename?: 'DocumentAsset' };

export type AssetForensicallyWatermarked_FileAsset_Fragment = { __typename?: 'FileAsset' };

export type AssetForensicallyWatermarked_FolderAsset_Fragment = { __typename?: 'FolderAsset' };

export type AssetForensicallyWatermarked_ImageAsset_Fragment = { __typename?: 'ImageAsset' };

export type AssetForensicallyWatermarked_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset' };

export type AssetForensicallyWatermarked_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset' };

export type AssetForensicallyWatermarked_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, forensicallyWatermarked?: boolean | null };

export type AssetForensicallyWatermarked_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset' };

export type AssetForensicallyWatermarked_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset' };

export type AssetForensicallyWatermarked_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, forensicallyWatermarked?: boolean | null };

export type AssetForensicallyWatermarkedFragment = AssetForensicallyWatermarked_AudioAsset_Fragment | AssetForensicallyWatermarked_DocumentAsset_Fragment | AssetForensicallyWatermarked_FileAsset_Fragment | AssetForensicallyWatermarked_FolderAsset_Fragment | AssetForensicallyWatermarked_ImageAsset_Fragment | AssetForensicallyWatermarked_InteractiveAsset_Fragment | AssetForensicallyWatermarked_InteractiveLiveAsset_Fragment | AssetForensicallyWatermarked_ModelAsset_Fragment | AssetForensicallyWatermarked_UnsupportedAsset_Fragment | AssetForensicallyWatermarked_VersionStackAsset_Fragment | AssetForensicallyWatermarked_VideoAsset_Fragment;

export const AccountForensicWatermarkingPolicies = /*#__PURE__*/ gql`
    fragment AccountForensicWatermarkingPolicies on Account {
  id
  resourceControlPolicies {
    forensicWatermark {
      adminInternal
      adminCanDisableInShares
      commentOnlyInternal
      editAndShareInternal
      editAndShareCanDisableInShares
      editInternal
      fallback
      fullAccessInternal
      fullAccessCanDisableInShares
      requiredForShares
      viewerInternal
    }
  }
}
    ` as unknown as DocumentNode<AccountForensicWatermarkingPoliciesFragment, unknown>;
export const WorkspaceForensicWatermarkingPolicies = /*#__PURE__*/ gql`
    fragment WorkspaceForensicWatermarkingPolicies on Workspace {
  id
  resourceControlPolicies {
    forensicWatermark {
      adminInternal
      adminCanDisableInShares
      commentOnlyInternal
      editAndShareInternal
      editAndShareCanDisableInShares
      editInternal
      fallback
      fullAccessInternal
      fullAccessCanDisableInShares
      requiredForShares
      viewerInternal
    }
  }
}
    ` as unknown as DocumentNode<WorkspaceForensicWatermarkingPoliciesFragment, unknown>;
export const ShareForensicWatermarkingPolicies = /*#__PURE__*/ gql`
    fragment ShareForensicWatermarkingPolicies on Share {
  id
  forensicWatermarkEnabled
  project {
    id
    appliedResourceControlPolicies {
      forensicWatermark {
        requiredForShares
      }
    }
    permissions {
      canDisableForensicWatermarkingInShares
    }
  }
}
    ` as unknown as DocumentNode<ShareForensicWatermarkingPoliciesFragment, unknown>;
export const AssetForensicallyWatermarked = /*#__PURE__*/ gql`
    fragment AssetForensicallyWatermarked on Asset {
  ... on VideoAsset {
    id
    forensicallyWatermarked
  }
  ... on ModelAsset {
    id
    forensicallyWatermarked
  }
}
    ` as unknown as DocumentNode<AssetForensicallyWatermarkedFragment, unknown>;

        

        
export const useAccountForensicWatermarkingPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<AccountForensicWatermarkingPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<AccountForensicWatermarkingPoliciesFragment>({
    fragment: AccountForensicWatermarkingPolicies,
    fragmentName: 'AccountForensicWatermarkingPolicies',
    ...options,
  });
};
  
        
        

        
export const useWorkspaceForensicWatermarkingPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceForensicWatermarkingPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceForensicWatermarkingPoliciesFragment>({
    fragment: WorkspaceForensicWatermarkingPolicies,
    fragmentName: 'WorkspaceForensicWatermarkingPolicies',
    ...options,
  });
};
  
        
        

        
export const useShareForensicWatermarkingPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<ShareForensicWatermarkingPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareForensicWatermarkingPoliciesFragment>({
    fragment: ShareForensicWatermarkingPolicies,
    fragmentName: 'ShareForensicWatermarkingPolicies',
    ...options,
  });
};
  
        
        

        
export const useAssetForensicallyWatermarkedFragment = (
  input: string | Omit<UseFragmentOptions<AssetForensicallyWatermarkedFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetForensicallyWatermarkedFragment>({
    fragment: AssetForensicallyWatermarked,
    fragmentName: 'AssetForensicallyWatermarked',
    ...options,
  });
};
  
        